const ClientInvoiceReportOrderOptionsArray = [
  { value: null, label: '' },
  { value: 'EvalDate', label: 'Assignment Date' },
  { value: 'UnitName', label: 'Location Name' },
  { value: 'UnitId', label: 'Apollo Location ID' },
];

export default ClientInvoiceReportOrderOptionsArray;
